







































































import {
  defineComponent, reactive, toRefs, watch, computed,
} from '@vue/composition-api'

import { AuthUserRolesT, AUTHUSERROLE, rolesOverlapsRoleList } from '@/auth/authRoles'
import { vxm } from '@/state/index'

// vetur (linter) complains about this next line, but it is OK. TODO: fix later
import sassVariablesJson from '@/styles/variables.json'

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: undefined,
    },
  },

  setup(props, context) {
    const state = reactive({
      drawer: null,
      appNameStyle: `font-family: ${sassVariablesJson['my-heading-font-family']};
      font-size: 22px; letter-spacing: 0.034em`,
      /**
       * Navigation items
       *
       * Note: The `access` prop only controls if a section is shown or not here
       * in the main navigation. It is the router that controls the actual route
       * access based on a similar role check. In the future you could align the two.
       */
      navSections: [
        {
          access: [AUTHUSERROLE.THERAPIST, AUTHUSERROLE.ADMIN, AUTHUSERROLE.DEV],
          items: [
            {
              route: { name: 'clients' },
              title: 'Mine klienter',
              icon: context.root.$vuetify.icons.values.clients,
            },
          ],
        },
        {
          title: 'RESEARCH',
          access: [AUTHUSERROLE.ADMIN, AUTHUSERROLE.DEV],
          items: [
            {
              route: { name: 'studyCases', params: { studyId: 'epias01' } },
              title: 'EPIAS',
              icon: 'mdi-microscope',
              exact: false,
            },
          ],
        },
        {
          title: 'DEV',
          access: [AUTHUSERROLE.DEV, AUTHUSERROLE.ADMIN, AUTHUSERROLE.THERAPIST],
          items: [
            {
              route: { name: 'layout' },
              title: 'Layout',
              icon: 'mdi-page-layout-body',
            },
            {
              route: { name: 'apitest' },
              title: 'API',
              icon: 'mdi-api',
            },
            {
              route: { name: 'sysinfo' },
              title: 'System info',
              icon: 'mdi-server',
            },
          ],
        },
      ],
    })

    const userHasAccess = (roles: AuthUserRolesT | undefined) => {
      if (roles === undefined) return false
      return rolesOverlapsRoleList(vxm.authUser.roles, roles)
    }

    // eslint-disable-next-line max-len
    const accessibleNavSections = computed(() => state.navSections.filter((section) => userHasAccess(section.access)))

    watch(
      () => props.show, () => { (state.drawer as unknown as boolean) = !state.drawer },
    )

    return {
      ...toRefs(state),
      accessibleNavSections,
    }
  },
})
